class WidgetValue {
  constructor(private readonly _value: string = "") {
  }

  public isEmpty(): boolean {
    return this._value === "";
  }

  get value() {
    return this._value;
  }
}

export default WidgetValue;
